export const modelDownText = {
    en: "We are facing some system issue.",
    hi: "सिस्टम मे कुछ समस्या पाई गई है।",
    or: "ଆମେ କିଛି ସିଷ୍ଟମ୍ ସମସ୍ୟା ସମ୍ମୁଖୀନ ହେଉଛୁ।",
    mr: "आम्हाला काही सिस्टम समस्येचा सामना करावा लागत आहे."
  };
  
  export const liveText = {
    en: "System is up!",
    hi: "सिस्टम फिर से चालू हो गया है!",
    or: "ସିଷ୍ଟମ୍ ପୁନଃ ଚାଲୁ ହୋଇଯାଇଛି!",
    mr: "सिस्टम पुन्हा सुरू झाले आहे!"
  };
  
  export const downText = {
    default: {
      en: "We are facing some system issue.",
      hi: "सिस्टम मे कुछ समस्या पाई गई है।",
      or: "ଆମେ କିଛି ସିଷ୍ଟମ୍ ସମସ୍ୟା ସମ୍ମୁଖୀନ ହେଉଛୁ।",
      mr: "आम्हाला काही सिस्टम समस्येचा सामना करावा लागत आहे."
    },
    modelDown: {
      en: "I am experiencing a problem in generating a response. Please try again.",
      hi: "मुझे जवाब तैयार करने में समस्या आ रही है। कृपया पुनः प्रयास करें।",
      or: "ଉତ୍ତର ତିଆରି କରିବାରେ ସମସ୍ୟା ହେଉଛି। ଦୟାକରି ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ।",
      mr: "मला उत्तर तयार करण्यात समस्या येत आहे. कृपया पुन्हा प्रयत्न करा."
    },
    middlewareDown: {
      en: "We are facing some system issue. Please try again.",
      hi: "सिस्टम मे कुछ समस्या पाई गई है। कृपया पुनः प्रयास करें।",
      or: "ଆମେ କିଛି ସିଷ୍ଟମ୍ ସମସ୍ୟା ସମ୍ମୁଖୀନ ହେଉଛୁ। ଦୟାକରି ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ।",
      mr: "आम्हाला सिस्टममध्ये काही समस्या येत आहेत. कृपया पुन्हा प्रयत्न करा."
    }
  };
  
  export const retryLiveText = {
    en: "Trying to connect...",
    hi: "कनेक्ट करने की कोशिश कर रहे हैं...",
    or: "ଯୋଗାଯୋଗ କରିବାକୁ ଚେଷ୍ଟା କରାଯାଉଛି...",
    mr: "कनेक्ट करण्याचा प्रयत्न करत आहोत..."
  };
  
  export const tryAgainLiveText = {
    en: "Try again",
    hi: "फिर से प्रयास करें।",
    or: "ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ", 
    mr: "पुन्हा प्रयत्न करा"
  };
  